import { Box, Button, SxProps, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import SelectedFiltersTags from './selected-filters-tags';
import { pxToRem } from '@/theme/typography';

export interface selectedFilters {
  id: number;
  type: 'cinema' | 'experience';
  label?: string;
}
interface SelectedFiltersProps {
  selectedFilters: selectedFilters[];
  seeResultsDisabled: boolean;
  handleDeleteSelectedFilter: (filter: selectedFilters) => void;
  clearFilters: () => void;
  submitFilters: () => void;
}
export const SelectedFilters: FC<SelectedFiltersProps> = ({
  selectedFilters,
  seeResultsDisabled,
  handleDeleteSelectedFilter,
  clearFilters,
  submitFilters,
}) => {
  const theme = useTheme();

  const sx: SxProps = {
    fontWeight: '700',
    fontSize: pxToRem(28),
    lineHeight: '32px',
    color: theme.palette.grey[90],
    textAlign: 'start',
  };

  return (
    <Box>
      <>
        <Typography
          sx={{
            ...sx,
            fontSize: pxToRem(20),
            marginTop: pxToRem(32),
          }}
        >
          <FormattedMessage id='movie_details.selected.filters' />
        </Typography>
        {selectedFilters.length === 0 && (
          <Typography
            sx={{
              fontSize: pxToRem(20),
              fontWeight: '400',
              marginTop: pxToRem(16),
              color: theme.palette.grey[50],
              textAlign: 'start',
            }}
          >
            <FormattedMessage id='movie_details.no.selected.filters' />
          </Typography>
        )}
        {selectedFilters.length > 0 && (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', marginTop: pxToRem(16) }}>
            <SelectedFiltersTags
              selectedFilters={selectedFilters}
              handleDeleteSelectedFilter={handleDeleteSelectedFilter}
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: pxToRem(24),
                width: '100%',
              }}
            >
              <Button
                variant='text'
                sx={{
                  padding: `${pxToRem(16)} ${pxToRem(20)}`,
                  width: pxToRem(180),
                  color: theme.palette.grey[70],
                }}
                onClick={() => clearFilters()}
              >
                <FormattedMessage id='movie_details.clear.all' />
              </Button>
              <Button
                variant='contained'
                sx={{
                  padding: `${pxToRem(16)} ${pxToRem(20)}`,
                  width: pxToRem(180),
                  height: { tablet: pxToRem(56), mobile: '56px' },
                }}
                onClick={() => submitFilters()}
                disabled={seeResultsDisabled}
              >
                <FormattedMessage id='movie_details.see.results' />
              </Button>
            </Box>
          </Box>
        )}
      </>
    </Box>
  );
};

export default SelectedFilters;
